import { render, staticRenderFns } from "./TicketDetailPage.vue?vue&type=template&id=7ab98b90&"
import script from "./TicketDetailPage.vue?vue&type=script&lang=ts&"
export * from "./TicketDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports